import { makeStyles } from '@material-ui/core';

export const useDocumentDialogStyles = makeStyles(() => ({
  container: {},
  paperWidthSm: {
    maxWidth: '40rem',
  },
}));
